import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"
import { AppShell } from "@/components/layout/app-shell"
import { useAuthStore } from "@/stores/auth-store"
import { useTokenRefresh } from "@/lib/hooks/use-token-refresh"
import { useTelemetryIdentity } from "@/lib/telemetry/hooks"
import { captureError } from "@/lib/telemetry/sentry"
import { PageLoader } from "@/components/ui/page-loader"
import { PageError } from "@/components/ui/page-error"

export const Route = createFileRoute("/_authenticated")({
  beforeLoad: () => {
    const isAuthenticated = useAuthStore.getState().isAuthenticated
    if (!isAuthenticated) {
      throw redirect({ to: "/login" })
    }
  },
  component: AuthenticatedLayout,
  pendingComponent: () => <PageLoader message="Loading..." />,
  errorComponent: ({ error }) => {
    captureError(error)
    return <PageError error={error as Error} />
  },
})

function AuthenticatedLayout() {
  useTokenRefresh()
  useTelemetryIdentity()

  return (
    <AppShell>
      <Outlet />
    </AppShell>
  )
}
